module.exports = __webpack_public_path__ + "img/电视机背板4.36fe7862.jpg";